import {EditorSimpleSelect} from "./editor-simple-select";

export class EditorDeleteSelect extends EditorSimpleSelect {
  buildInitialState(options: any): any {
    this.controller.interaction.attemptDeleteFocus();
    return super.buildInitialState(options);
  }
}
